import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import About from "../components/About";

export default withRouter(connect()(About));
